/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Calendar_EventsInputs */

const ja_calendar_events = /** @type {(inputs: Calendar_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`EVENTS BY PLAYBRAIN`)
};

const en_calendar_events = /** @type {(inputs: Calendar_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`EVENTS BY PLAYBRAIN`)
};

/**
* | output |
* | --- |
* | "EVENTS BY PLAYBRAIN" |
*
* @param {Calendar_EventsInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const calendar_events = /** @type {((inputs?: Calendar_EventsInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Calendar_EventsInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_calendar_events(inputs)
	return en_calendar_events(inputs)
});